export function normalizeAdditionalSpecs(list) {
  if (!Array.isArray(list)) return []
  return list
    .map((item) => ({
      key: String(item?.key ?? '').trim(),
      value: String(item?.value ?? '').trim(),
    }))
    .filter((item) => item.key && item.value)
}

export function toSpecEditorRows(list) {
  return normalizeAdditionalSpecs(list).map((item, index) => ({
    id: `spec-${index}-${item.key}`,
    key: item.key,
    value: item.value,
  }))
}
